// extracted by mini-css-extract-plugin
export default {"root":"AddressAutocomplete_root__hT3o1","popper":"AddressAutocomplete_popper__xO+Ee","options":"AddressAutocomplete_options__GjgVB","option":"AddressAutocomplete_option__7FyI8"};